<template>
        <div class="container" :class="{'bodyfont-unauth': !user}">
            <h2 v-bind:style="{ color: getCorpHeadingColor, textTransform:'unset !important'}">Meet Our Experts and Hosts</h2>
            <!--<p>-->
                <!--While we can't give you back time, we can make it easier to give back to others. This is why we created Clicks For Good. The more time you spend on TONE, the more we'll donate to the charity of your choice. Thanks for helping us out!-->
            <!--</p>-->
            <!--/////////////////////////////////////////////////////////////////////-->
            <div class="expertsrow">
                <div class="expert-entery"  v-for="expert in getAllExperts" :id="(expert.expertId * 115)">
<!--                <div class="expert-entery"  v-for="expert in getAllExperts" :id="(expert.expertId * 115)" @mouseover="triggerPopup(expert.expertId * 115)"-->
<!--                     @mouseout="clear(expert.expertId * 115)">-->
                    <div class="expert_entry_holder" :id="expert.expertId">
                        <div class="expert_entry_image-and-name-container">
                            <!--<img v-bind:src="charity.img_url" alt="">-->
                            <router-link :to="{ path: '/expert/' + expert.expertId + '/' + expert.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}" >
                                <!--<a :href="'#/expert/' + expert.expertId" class="sqareimg-expert">-->
                                <img class="img-responsive" :src="expert.small_image" :alt="expert.name" :title="expert.name"/>
                                <!--</a>-->
                            </router-link>
                            <!--<h3>{{charity.name}}<br><small><a class="weblink" target="_new" v-bind:href="charity.website">{{ charity.website }}</a></small></h3>-->
                            <h2>
                                <router-link :to="{ path: '/expert/' + expert.expertId + '/' + expert.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}" >
                                    {{expert.name}}
                                </router-link>
                                <!--<a :href="'#/expert/' + expert.expertId">{{expert.name}}-->
                                <!--</a><br />-->
                                <br />
                                <small>{{expert.experties}}</small>
                            </h2>
                        </div>
                        <div class="expert_entry_datacontainer">
                            <h1>{{expert.name}}</h1>
                            <h3>{{expert.experties}}</h3>
                            <p> {{expert.areasofexpertise}}</p>
                            <router-link class="pink-button" :to="{ path: '/expert/' + expert.expertId + '/' + expert.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}" >
                                <strong>Find out More</strong>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="contactformtexttone contact-form">
                <a href="javascript:" @click="$router.push('/become-expert')"><h3>Want to become a TONE Expert?</h3></a>

                <!--<p>-->
                    <!--TONE is a platform for women helping women in all areas of life. We look for experts in fields that can help women grow professionally and personally to live life to the fullest potential. Our experts are highly credentialed, successful in their fields and passionate about helping women. TONE underwrites production and related expenses, and experts are not paid a fee for their appearances. Please complete this form and tell us about yourself and why you would be a great addition to TONE.-->
                <!--</p>-->
                <!--<p>-->
                    <!--Fully completed forms should be sent to <a href="mailto:experts@tonenetworks.com"> experts@tonenetworks.com</a>-->
                <!--</p>-->
                <!--<p><a href="https://s3.amazonaws.com/assets.tonenetworks.com/resources/Become_Expert_Form.pdf" class="pinklinkcontectext" donwload="Become_Expert_Form.pdf" target="_blank"> Become a Tone Expert (PDF)</a></p>-->
            </div>
            </div>
        <!--<modal v-if="showModal" effect="zoom" :value="showModal" @cancel="cancelModal()" width="915">-->
            <!--<div slot="modal-header"></div>-->
            <!--<div slot="modal-body" class="modal-body">-->
                <!--<h4 v-if="getSelectedCharity === null">Ready to make your charity selection?</h4>-->
                <!--<h4 v-else>Ready to change your charity selection?</h4>-->
                <!--<div class="selectedImage">-->
                    <!--<img v-bind:src="currentCharity.img_url" alt="LOGO" v-bind:title="currentCharity.title">-->
                <!--</div>-->
                <!--<a class="cursor" @click="cancelModal()">No Thanks</a>-->
                <!--&lt;!&ndash;<template v-if="currentCharity === null">-->
                    <!--<button type="button" @click="changeCharity()">Yes, change my selection</button>-->
                <!--</template>-->
                <!--<template v-else>-->
                    <!--<button type="button" @click="changeCharity()">Yes, make my selection</button>-->
                <!--</template>&ndash;&gt;-->

            <!--</div>-->
            <!--<div slot="modal-footer"></div>-->
        <!--</modal>-->
        <!--<modal v-if="showModal_player" effect="zoom" :value="showModal_player" @cancel="cancelModal_player()" width="400">-->
            <!--<div slot="modal-header"></div>-->
            <!--<div slot="modal-body" class="modal-body">-->
                <!--<jwplayer :data="currentPlayerID">Loading the player...</jwplayer>-->
            <!--</div>-->
            <!--<div slot="modal-footer"></div>-->
        <!--</modal>-->
    <!--</div>-->
</template>

<script>
    import jwplayer from './JwPlayer.vue'
    import JwPlayList from './JwPlayList.vue'
    import {modal, spinner} from 'vue-strap'
    import { mapGetters } from 'vuex'
    import $ from 'jquery'

    export default {
        components: {
            jwplayer,
            modal: modal,
            'jwplaylist': JwPlayList,
            'spinner': spinner
        },
        metaInfo () {
            let self = this
            return {
                title: self.metaTag_pageTitle,
                meta: [
                    {name: 'keywords', content: self.metaTag_keywords},
                    {name: 'description', content: self.metaTag_description},
                    {property: 'og:image', content: self.metaTag_fb_image},
                    {property: 'og:title', content: self.metaTag_fb_title},
                    {property: 'og:site_name', content: self.metaTag_fb_sitename},
                    {
                        property: 'og:description',
                        content: self.metaTag_fb_description
                    },
                    {property: 'twitter:title', content: self.metaTag_tw_title},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: self.metaTag_tw_image},
                    {
                        property: 'twitter:description',
                        content: self.metaTag_tw_description
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        name: 'giving',
        data: function () {
            return {
                timerRef: null,
                elementRef: '',
                isHover: false,
                activeClass: false,
                spinner: false,
                showModal_player: false,
                metaTag_pageTitle: 'TONE | Our Experts',
                metaTag_description: '',
                metaTag_keywords: '',
                metaTag_fb_image: '',
                metaTag_fb_title: '',
                metaTag_fb_description: '',
                metaTag_fb_sitename: '',
                metaTag_tw_image: '',
                metaTag_tw_title: '',
                metaTag_tw_description: ''
            }
        },
        computed: {...mapGetters([
            'getAllExperts', 'user', 'getAllSiteContents', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'])},
        mounted: function () {
            // let self = this
            this.$store.dispatch('GETDYNAMICCONTENTS', 20).then(() => {
                if (this.getAllSiteContents) {
                    // Load Meta Tags
                    this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                    this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                    this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                    // OpenGraph Tags
                    this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                    this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                    this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                    this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                    // Twitter Tags
                    this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                    this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                    this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                }
            })
            console.log('user', this.user)
            if (this.user && this.user.corporation) { // corporate user, change list list of experts
                this.$store.dispatch('GETALLEXPERTS_CORPORATION', this.user.corporation.corporationId).then(() => {
                    $('.expert_entry_holder').on('click', function () {
                        // console.info('clicked')
                        let clickedDiv = $(this)[0].id
                        console.log('selected div', clickedDiv)
                        let oldDiv = ''
                        let activeRef = $('.expert_entry_holder').find('.active')
                        // console.log('is active', activeRef)
                        if (activeRef[0] === undefined) { // Verify if there is an element clicked already
                        } else {
                            oldDiv = activeRef[0].id
                        }
                        $('.expert_entry_holder').removeClass('active')
                        if (clickedDiv !== oldDiv) {
                            $(this).addClass('active')
                        }
                    })
                    // $('.expert-entery').mouseenter(function (ev) {
                    //     if (self.timerRef && self.elementRef) {
                    //         clearTimeout(self.timerRef)
                    //         $(self.elementRef).removeClass('hoveringeffect')
                    //         self.elementRef = null
                    //         self.timerRef = null
                    //     }
                    //     self.timerRef = setTimeout(function () {
                    //         // img-responsive
                    //         let className = $(ev.target).attr('class')
                    //         if (className === 'expert-entery') {
                    //             self.elementRef = $(ev.target)
                    //         } else if (className === 'img-responsive') {
                    //             self.elementRef = $(ev.target).parent().parent().parent().parent()
                    //         }
                    //         console.log('this reference', $(ev.target))
                    //         console.log('this reference reference', self.elementRef)
                    //         $(self.elementRef).addClass('hoveringeffect')
                    //     }, 700)
                    // }).mouseleave(function (ev) {
                    //     clearTimeout(self.timerRef)
                    //     $(self.elementRef).removeClass('hoveringeffect')
                    // })
                })
            } else {
                let corpId = 0
                // Is user is for gift or else pass 0
                if (localStorage.getItem('corporateClientObject')) {
                    let corpObject = JSON.parse(localStorage.getItem('corporateClientObject'))
                    corpId = corpObject.corporationId
                }
                this.$store.dispatch('GETALLEXPERTS_CORPORATION', corpId).then(() => {
                    $('.expert_entry_holder').on('click', function () {
                        // console.info('clicked')
                        let clickedDiv = $(this)[0].id
                        console.log('selected div', clickedDiv)
                        let oldDiv = ''
                        let activeRef = $('.expert_entry_holder').find('.active')
                        // console.log('is active', activeRef)
                        if (activeRef[0] === undefined) { // Verify if there is an element clicked already
                        } else {
                            oldDiv = activeRef[0].id
                        }
                        $('.expert_entry_holder').removeClass('active')
                        if (clickedDiv !== oldDiv) {
                            $(this).addClass('active')
                        }
                    })
                    // $('.expert-entery').mouseenter(function (ev) {
                    //     if (self.timerRef && self.elementRef) {
                    //         clearTimeout(self.timerRef)
                    //         $(self.elementRef).removeClass('hoveringeffect')
                    //         self.elementRef = null
                    //         self.timerRef = null
                    //     }
                    //     self.timerRef = setTimeout(function () {
                    //         // img-responsive
                    //         let className = $(ev.target).attr('class')
                    //         if (className === 'expert-entery') {
                    //             self.elementRef = $(ev.target)
                    //         } else if (className === 'img-responsive') {
                    //             self.elementRef = $(ev.target).parent().parent().parent().parent()
                    //         }
                    //         console.log('this reference', $(ev.target))
                    //         console.log('this reference reference', self.elementRef)
                    //         $(self.elementRef).addClass('hoveringeffect')
                    //     }, 700)
                    // }).mouseleave(function (ev) {
                    //     clearTimeout(self.timerRef)
                    //     $(self.elementRef).removeClass('hoveringeffect')
                    // })
                })
            }
            // this.$store.dispatch('GETALLEXPERTS').then(() => {
            //     $('.expert_entry_holder').on('click', function () {
            //         // console.info('clicked')
            //         let clickedDiv = $(this)[0].id
            //         console.log('selected div', clickedDiv)
            //         let oldDiv = ''
            //         let activeRef = $('.expert_entry_holder').find('.active')
            //         // console.log('is active', activeRef)
            //         if (activeRef[0] === undefined) { // Verify if there is an element clicked already
            //         } else {
            //             oldDiv = activeRef[0].id
            //         }
            //         $('.expert_entry_holder').removeClass('active')
            //         if (clickedDiv !== oldDiv) {
            //             $(this).addClass('active')
            //         }
            //     })
            //     // $('.expert-entery').mouseenter(function (ev) {
            //     //     if (self.timerRef && self.elementRef) {
            //     //         clearTimeout(self.timerRef)
            //     //         $(self.elementRef).removeClass('hoveringeffect')
            //     //         self.elementRef = null
            //     //         self.timerRef = null
            //     //     }
            //     //     self.timerRef = setTimeout(function () {
            //     //         // img-responsive
            //     //         let className = $(ev.target).attr('class')
            //     //         if (className === 'expert-entery') {
            //     //             self.elementRef = $(ev.target)
            //     //         } else if (className === 'img-responsive') {
            //     //             self.elementRef = $(ev.target).parent().parent().parent().parent()
            //     //         }
            //     //         console.log('this reference', $(ev.target))
            //     //         console.log('this reference reference', self.elementRef)
            //     //         $(self.elementRef).addClass('hoveringeffect')
            //     //     }, 700)
            //     // }).mouseleave(function (ev) {
            //     //     clearTimeout(self.timerRef)
            //     //     $(self.elementRef).removeClass('hoveringeffect')
            //     // })
            // })
            this.$store.dispatch('CACHEPAGE', window.location.href)
        },
        methods: {
            triggerPopup (identifier) {
                let self = this
                self.elementRef = identifier
                console.log('identifier', self.elementRef)
                setTimeout(function () {
                    if (self.elementRef === identifier) {
                        $(`#${self.elementRef}`).addClass('hoveringeffect')
                    }
                }, 400)
            },
            clear (elementRef) {
                let self = this
                $(`#${self.elementRef}`).removeClass('hoveringeffect')
                this.elementRef = ''
            },
            setDynamicSection (coll, key) {
                let valCol = coll.filter(x => {
                    return x.content_id === key
                })
                if (valCol && valCol.length > 0) {
                    return valCol[0].content_value
                } else {
                    return ''
                }
            },
            setPlayer (playerObject) {
                this.currentPlayerID = {video: playerObject.sources[1].file, title: playerObject.title, img: playerObject.image, playerID: new Date()}
                this.showModal_player = true
            },
            active () {
                this.activeClass = true
            },
            switchTab: function (id) {
                for (let tab in this.tabs) {
                    this.tabs[tab] = id === tab
                }
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            openModal (charity) {
                this.currentCharity = charity
                this.showModal = true
            },
            cancelModal () {
                this.showModal = false
                var self = this
                setTimeout(function () {
                    self.showModal = false
                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            changeCharity (charity) {
                this.currentCharity = charity
                var info = [this.currentCharity.charityId, this.user.userId]
                // this.spinnerToggle()
                this.$store.dispatch('SETSELECTEDCHARITY', info).then(() => {
                    this.$store.dispatch('GETSELECTEDCHARITY', this.user.userId).then(() => {
                       // this.spinnerToggle()
                        this.currentCharity.selectedCharity = !this.currentCharity.selectedCharity
                    })
                    // this.showModal = false
                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                    // $('.modal-open').removeClass('modal-open')
                })
            },
            checkCharity (charity) {
                return this.getSelectedCharity.charityId === charity.charityId
            },
            redirectToExpert (expert) {
                this.$router.push(`/expert/${expert.expertId}`)
            },
            cancelModal_player () {
                var self = this
                var $ = window.jQuery
                setTimeout(function () {
                    self.showModal_player = false
                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            }
        }
    }
</script>
<style scoped>
    .expert_entry_image-and-name-container img.img-responsive {
        object-position: top;
    }
    .expert_entry_image-and-name-container > a {
        background: #fff !important;
    }
    .weblink {
        text-transform: lowercase;
        font-size: 14px;
        line-height: 1.3;
        display:block;
        text-indent:1.5px;
    }
    .row.expertsrow {
        margin-bottom: 30px;
        margin-top: 50px;
    }

    .row.expertsrow h2 {
        color: #000000;
        font-size: 40px;
        font-family: sans-serif;
        margin: 30px 0 15px 0;
        text-align: left;
        text-transform: capitalize;
        letter-spacing: 0.3px;
    }

    .row.expertsrow h2 small {
        color: #f0617d;
        letter-spacing: 1px;
    }
    .row.expertsrow p{
        font-size:20px;
        color:#000;
        letter-spacing:1px;
    }
    h2{
        color: #f0617d;
        text-transform: capitalize;
        margin: 35px 0 60px 0;
        letter-spacing: 0.5px;
        font-family: sans-serif;
    }
    a:hover {
        text-decoration: none;
    }
    /*changes in experts layout 1*/
    .expertsrow {
        margin: 30px -15px;
        display: flex;
        flex-wrap: wrap;
    }

    .expert-entery {
        width: 25%;
        padding: 15px;
        position: relative;
    }


    .expert_entry_image-and-name-container img.img-responsive {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100%;
        object-fit: cover;
        width: 100%;
    }


    .expert_entry_image-and-name-container > a {
        position: relative;
        width: 100%;
        padding-top: 100%;
        display: block;
    }

    .expert_entry_datacontainer {
        position: absolute;
        left: 100%;
        right: auto;
        top: 0;
        z-index: 100;
        background: #44bda8;
        width: 200%;
        min-height: 100%;
        display: none;
        align-items: center;
        padding: 20px;
        text-align: left;
        color: #fff;
        font-size: 17px;
        flex-direction: column;
        justify-items: stretch;
        justify-content: center;
    }

    .expert_entry_datacontainer p {
        width: 100%;
        display: block;
    }

    .expert_entry_holder {
        position: relative;
    }

    .expert_entry_datacontainer:before {
        display: block;
        content: "";
        height: 0;
        width: 0;
        left: -100px;
        border: 50px solid #f0617d00;
        border-right: 50px solid #44bda8;
        position: absolute;
        top: 80px;
    }

    .expert_entry_holder:hover .expert_entry_datacontainer {
        /*display: flex ;*/
    }

    .expert_entry_datacontainer > a {
        background: white;
        padding: 5px 30px;
        border-radius: 20px;
    }
    .expert_entry_image-and-name-container h2 {
        font-size: 22px;
        margin: 10px 0;
    }
    @media(min-width:768px){
        .expert-entery:nth-of-type(4n+3) .expert_entry_datacontainer {
            right: 100%;
            left: auto;
        }

        .expert-entery:nth-of-type(4n+3) .expert_entry_datacontainer:before {
            left: auto;
            border: 50px solid #f0617d00;
            border-left: 50px solid #44bda8;
            right: -100px;
        }
        .expert-entery:nth-of-type(4n+0) .expert_entry_datacontainer {
            right: 100%;
            left: auto;
        }

        .expert-entery:nth-of-type(4n+0) .expert_entry_datacontainer:before {
            left: auto;
            border: 50px solid #f0617d00;
            border-left: 50px solid #44bda8;
            right: -100px;
        }
    }
    .expert_entry_image-and-name-container {
        background: #44bda8;
    }
    .expert_entry_image-and-name-container h2 *, .expert_entry_image-and-name-container h2 small {
        color: #fff;
    }
    .expert_entry_image-and-name-container:after {content: "";display: table;}
    .expert_entry_image-and-name-container h2 {
        min-height: 72px;
    }
    /*second css*/
       .expert_entry_datacontainer {
        opacity: 0;
        /*background-color: red;*/
        animation-name: popout;
        animation-duration: 0.5s;
        animation-delay: 0.1s;
        animation-fill-mode: forwards;
    }

    @keyframes popout {
        from {opacity: 0;}
        to {opacity: 1;}
    }
    /*third css*/
    @media(max-width:767px){
        .expert_entry_holder:active .expert_entry_datacontainer,
        .expert_entry_holder:focus .expert_entry_datacontainer {
            left: 0;
            right: 0 !important;
            top: 0;
            bottom: 0;
            opacity: 1;
            animation-name: none;
            width:100%;
        }
    }
    @media(max-width:767px){
        .expert-entery{
            width:100% !important;
        }
        .expert_entry_holder.active .expert_entry_datacontainer{left: 0;right: 0 !important;top: 0;bottom: 0;display: flex;opacity: 1 !important;animation-name: none;animation-delay: 0s;width:100%;}
        .expert_entry_holder.active .expert_entry_datacontainer:before{display:none;}
    }
    @media(max-width:767px){
        .expert_entry_holder:hover .expert_entry_datacontainer{
            left: 0;
            right: 0 !important;
            width: 100%;
        }
    }
    @media(max-width:767px){
        .expert_entry_datacontainer > p {
            max-height: 50vw;
            display: -webkit-box;
            -webkit-line-clamp: 6;
            /* autoprefixer: off */
            -webkit-box-orient: vertical;
            /* autoprefixer: on */
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .expert-entery:hover .expert_entry_holder .expert_entry_datacontainer {
        display: flex;
    }
    @media(max-width:767px){
        .expert_entry_image-and-name-container > a {
            pointer-events: none;
        }
    }
    @media(max-width:992px){
        .expert_entry_image-and-name-container:after {
            content: "More" !important;
            position: relative;
            bottom: 0%;
            left: 50%;
            background: #f0617d;
            z-index: 50;
            color: #fff;
            padding: 10px 30px;
            border-radius: 50px;
            font-size: 17px;
            transform: translate(-50%, 0%);
            margin-bottom:20px;
        }

.expert_entry_image-and-name-container{overflow:hidden;}
    }
</style>
<!--<style>-->
<!--    @media(max-width:767px){-->
<!--        .expert_entry_datacontainer > p {-->
<!--            -webkit-box-orient: vertical !important;-->
<!--            max-height: 50vw !important;-->
<!--            overflow: hidden !important;-->
<!--            text-overflow: ellipsis !important;-->
<!--            display: -webkit-box !important;-->
<!--            -webkit-line-clamp: 4 !important;-->
<!--        }-->
<!--    }-->
<!--</style>-->



// WEBPACK FOOTER //
// Experts.vue?58a609cc